import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { speedDetailsStyles } from './style';
import { Box } from '@mui/system';
import Slider from '@mui/material/Slider';
import useChangeBallSpeedFunctions from '../../../../hooks/useChangeBallSpeedFunctions/useChangeBallSpeedFunctions';
import { Typography, IconButton, Tooltip } from '@mui/material';
import { AddRounded, RemoveRounded } from '@mui/icons-material';

interface SpeedDetailsProps {
  initialValue: number;
  setInputValue: Dispatch<SetStateAction<number>>;
}

export const SpeedDetails: React.FC<SpeedDetailsProps> = props => {
  const { initialValue, setInputValue } = props;
  const { speedDetails } = speedDetailsStyles;
  const [value, setValue] = useState<number>(initialValue);
  const [tempValue, setTempValue] = useState<number>(initialValue);
  const minimum: number = 0;
  const maximum: number = 200;
  const step: number = 10;

  useEffect(() => {
    setInputValue(value / 100);
  }, [value, setInputValue]);

  const handleChange = (event: any, newValue: number | number[]) => {
    setTempValue(newValue as number);
  };

  const handleCommit = (event: any, newValue: number | number[]) => {
    setTempValue(newValue as number);
    setValue(newValue as number);
  };

  const handleDecrease = () => {
    const roundedValue = Math.ceil(tempValue / 10) * 10;

    if (roundedValue <= minimum) {
      setTempValue(minimum);
      setValue(minimum);
    } else {
      if (tempValue - roundedValue < 5) {
        setTempValue(roundedValue - step);
        setValue(roundedValue - step);
      } else {
        setTempValue(roundedValue);
        setValue(roundedValue);
      }
    }
  };

  const handleIncrease = () => {
    const roundedValue = Math.ceil(tempValue / 10) * 10;

    if (roundedValue >= maximum) {
      setTempValue(maximum);
      setValue(maximum);
    } else {
      if (roundedValue - tempValue < 5) {
        setTempValue(roundedValue + step);
        setValue(roundedValue + step);
      } else {
        setTempValue(roundedValue);
        setValue(roundedValue);
      }
    }
  };

  useChangeBallSpeedFunctions(handleDecrease, handleIncrease);

  return (
    <Box sx={speedDetails}>
      <Box className="container">
        <Slider
          orientation="vertical"
          value={tempValue}
          aria-label="Speed"
          onChange={handleChange}
          onChangeCommitted={handleCommit}
          max={maximum}
        />
        <Box className="value-container">
          <Typography className="value-container">{Math.round(value)}</Typography>
        </Box>
      </Box>
      <Box className="controls-container">
        <IconButton disabled={value >= maximum} className={'button increase'} onClick={handleIncrease}>
          <AddRounded />
        </IconButton>
        <IconButton disabled={value <= minimum} className={'button decrease'} onClick={handleDecrease}>
          <RemoveRounded />
        </IconButton>
      </Box>
    </Box>
  );
};
